import { useEffect, useState } from "react";
import logo from "./../../assets/cubes_with_background.png";
import SignUpModal from "../authentication/SignUpModal";
import LogInModal from "../authentication/LogInModal";
import { useAuth } from "../authentication/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { logAnalyticsEvent } from "../engagement/Amplitude";
import UserAvatar from "./UserAvatar";

export default function Header() {
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryValue = searchParams.get("q");
    if (queryValue) {
      setSearchQuery(queryValue);
    }
  }, [location]);

  const { user } = useAuth();

  const handleSearch = () => {
    const query = searchQuery;
    logAnalyticsEvent("Search", { query });
    console.log(query);
    navigate(`/search?q=${query}`);
  };

  return (
    <div>
      <div className="flex p-4 md:p-8 items-center h-12 md:h-16 border-b border-neutral/50 bg-base-100">
        <a
          className="btn btn-ghost text-xl px-0 mr-2 no-underline "
          href="/"
        >
          <div className="flex items-center gap-2 sm:gap-4  h-12">
            <img
              src={logo}
              alt="logo"
              className="rounded-lg w-8 md:w-10"
            />
            <div className="max-md:hidden">Code on the Rocks</div>
          </div>
        </a>
        <div className="input input-sm md:input-md min-w-0 input-bordered grow mr-2 sm:mr-4 flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="w-4 h-4 opacity-70 mr-2 sm:mr-4"
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
          <form
            className="w-full"
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            <input
              className="w-full"
              placeholder="Search"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </form>
        </div>
        {user ? (
          <UserAvatar />
        ) : (
          <div>
            <div className="max-sm:hidden">
              <button
                className="btn btn-outline btn-sm md:btn-md mr-4"
                onClick={() => {
                  logAnalyticsEvent("Press Log In");
                  setIsLoginOpen(true);
                }}
              >
                Log in
              </button>
              <button
                className="btn btn-primary btn-sm md:btn-md"
                onClick={() => {
                  logAnalyticsEvent("Press Sign Up");
                  setIsSignUpOpen(true);
                }}
              >
                Sign up
              </button>
            </div>
            <details className="dropdown dropdown-end sm:hidden w-20">
              <summary className="m-1 btn btn-sm">Log In</summary>
              <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-300 rounded-box w-52">
                <li>
                  <a
                    onClick={() => {
                      logAnalyticsEvent("Press Log In");
                      setIsLoginOpen(true);
                    }}
                  >
                    Log In
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      logAnalyticsEvent("Press Sign Up");
                      setIsSignUpOpen(true);
                    }}
                  >
                    Sign Up
                  </a>
                </li>
              </ul>
            </details>
          </div>
        )}
      </div>
      <SignUpModal
        isOpen={isSignUpOpen}
        onClose={() => setIsSignUpOpen(false)}
      />
      <LogInModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
      />
    </div>
  );
}
